import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ProjectPopoverMenuList from './PopoverMenuList'

interface ProjectTableActionButtonsProps {
  projectId: number
  projectName: string
  canManageProjects: boolean
  canCreateProjects: boolean
  canDeleteProjects: boolean
  canAssignEmployees: boolean
  hasSubprojectsFeature: boolean
}

const ActionButtons = ({
  projectId,
  projectName,
  canManageProjects,
  canCreateProjects,
  canDeleteProjects,
  canAssignEmployees,
  hasSubprojectsFeature,
}: ProjectTableActionButtonsProps) => {
  const { navigation } = useNavigation()

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      <ProjectPopoverMenuList
        projectId={projectId}
        projectName={projectName}
        canManageProjects={canManageProjects}
        canCreateProjects={canCreateProjects}
        canDeleteProjects={canDeleteProjects}
        canAssignEmployees={canAssignEmployees}
        hasSubprojectsFeature={hasSubprojectsFeature}
      />
      <Button.Router
        type="secondary"
        to={navigation.projects.id.fullPath({ id: projectId })}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default ActionButtons
